<div class="field grid">
  <label class="col-12 lg:col-4 md:col-4">{{ label }}</label>
  <div class="col">
    <ng-content></ng-content>
  </div>
</div>
